import React from 'react';
import ReactTooltip from 'react-tooltip';

import { Container } from './styles';

interface Props {
  label: string;
  color: string;
  disabled?: boolean;
  onClick?: () => void;
}

const ActionButton: React.FC<Props> = (props) => {
  return (
    <Container
      onClick={props.onClick}
      color={props.color}
      disabled={props.disabled}
      data-tip
      data-for={props.label}
    >
      {props.children}
      <ReactTooltip id={props.label} effect='solid'>
        <span>{props.label}</span>
      </ReactTooltip>
    </Container>
  );
};

export { ActionButton };
